import SideNav from './SideNav';
import { menuItems } from '@app_config/sideMenu';

const SideMenu = (props) => {
  const { user } = props;
  return <SideNav menu={menuItems} isAuthorized={user?.isRegistered} />;
};

export default SideMenu;
